module.exports = __webpack_public_path__ + "ac84cb0479bfccacdb7efb70c5b6385c.svg";